import { ClassNameProps } from "@/types";
import { StreamingIcons } from "@/assets/iconFont/streaming-icons";

enum RailVariant {
  Hero169 = "hero169",
  Hero34 = "hero34",
  ShowcaseCarousel = "showcase-carousel",
  Clips = "clips",
  Top10 = "top10",
}

interface RailProps
  extends ClassNameProps,
    React.HTMLAttributes<HTMLDivElement> {
  /**
   * Visual style of the rail, defaults to Hero34
   */
  variant?: RailVariant;

  /**
   * Optional rail title text
   */
  title?: string;

  /**
   * Optional rail icon
   */
  icon?: StreamingIcons;

  /**
   * Optional img src for rail icon
   */
  imgSrc?: string;

  /**
   * Whether the rail should be free scrolling or snap to each tile's position
   * Defaults to false
   */
  snap?: boolean;

  /**
   * Optional ref for the rail container
   */
  tileContainerRef?: React.Ref<HTMLDivElement>;
}

export { RailVariant };
export type { RailProps };
